import React, { useCallback, useState, useMemo } from "react";
import ReactPlayer from "react-player";
import LoadingIndicator from "react-loading-indicator";

import { resizeImage } from "../../../../../../utils/images";
import { isVideo } from "../../../utils";

import {
  CheckedWrapper,
  RemoveWrapper,
  BuyWrapper,
  CreativeWrapper,
  CreativeImg,
  CreativeVideoWrapper,
  Checked,
  Add,
  PlayIconWrapper,
  CustomPlayIcon,
  ShutterstockMark,
  ArchiveButton
} from "./AssetLibrary.styled";
import { isImageUrlUnlicensedStock } from "../../../../../../utils/Helpers";

const SHUTTERSTOCK = "shutterstock";

const CreativeOption = ({
  imageId,
  searchId,
  externalId,
  source,
  root,
  url,
  active,
  updateSelectedCreative,
  updateSelectedAsset,
  canBuyStockPicture,
  canBeEmpty,
  buyStockPicture,
  loadingStockPurchase,
  archivePicture
}) => {
  const [hovered, setHovered] = useState(false);

  const onMouseLeave = useCallback(() => setHovered(false), []);
  const onMouseEnter = useCallback(() => setHovered(true), []);

  const onClick = useCallback(() => {
    if (updateSelectedAsset) {
      if (source === SHUTTERSTOCK) {
        updateSelectedAsset({ imageId, searchId, source, url });
      } else if (root === SHUTTERSTOCK) {
        updateSelectedAsset({ imageId: externalId, source: root, url });
      } else {
        updateSelectedAsset(null);
      }
    }
    updateSelectedCreative(url);
  }, [url, updateSelectedCreative]);

  const onRemove = useCallback(
    (e) => {
      updateSelectedCreative("");
      e.stopPropagation();
    },
    [updateSelectedCreative]
  );

  const onBuyClicked = useCallback(() => {
    buyStockPicture(url);
  }, [url, buyStockPicture]);

  const onArchiveClicked = useCallback(
    (e) => {
      e.stopPropagation();
      archivePicture(url, root);
    },
    [url, archivePicture, root]
  );

  const isImageURL = useMemo(() => !isVideo(url), [url]);
  const showBuyStock = useMemo(
    () => canBuyStockPicture && isImageUrlUnlicensedStock(url),
    [url, canBuyStockPicture]
  );

  const showShutterstockMark = useMemo(() => root === SHUTTERSTOCK, [root]);

  const thumbnail = useMemo(() => resizeImage({ url, width: 300 }), [url]);

  return (
    <CreativeWrapper
      onClick={onClick}
      active={active}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {isImageURL ? (
        <CreativeImg src={thumbnail} alt="" />
      ) : (
        <CreativeVideoWrapper>
          <ReactPlayer
            url={url}
            loop
            playing={hovered}
            width="100%"
            height="auto"
            style={{ display: "flex" }}
            controls={false}
          />
          <PlayIconWrapper show={!hovered}>
            <CustomPlayIcon fill="#FFF" />
          </PlayIconWrapper>
        </CreativeVideoWrapper>
      )}

      <CheckedWrapper>
        <Checked fill="#1E22FF" />
      </CheckedWrapper>

      {canBeEmpty && <RemoveWrapper onClick={onRemove}>X</RemoveWrapper>}

      {showBuyStock && (
        <BuyWrapper onClick={onBuyClicked}>
          {loadingStockPurchase ? <LoadingIndicator /> : <Add fill="#1E22FF" />}
        </BuyWrapper>
      )}

      {showShutterstockMark && (
        <ShutterstockMark>
          <img src="/images/shutterstock_logo.svg" alt="shutterstock logo" />
        </ShutterstockMark>
      )}

      {archivePicture && (
        <ArchiveButton onClick={onArchiveClicked}>
          <img src="/images/close__white.svg" alt="archive button" />
        </ArchiveButton>
      )}
    </CreativeWrapper>
  );
};

export default CreativeOption;
